import {
    GET_APPROVAL_HISTORY_REPORT,
    SET_APPROVAL_HISTORY_REPORT,
    GET_APPROVAL_HISTORY_REPORT_EXCEL_DATA,
    SET_APPROVAL_HISTORY_REPORT_EXCEL_DATA,
    SET_APPROVAL_MANAGMENT_TAB,
    SET_APPROVAL_HISTORY_REPORT_FILTERS,
    GET_APPROVAL_HISTORY_REPORT_DETAILS,
    SET_APPROVAL_HISTORY_REPORT_DETAILS,
    GET_APPROVAL_HISTORY_DETAIL_EXCEL_DATA,
    SET_APPROVAL_HISTORY_DETAIL_EXCEL_DATA
} from "./ApprovalHistoryReportType"

const getApprovalHistoryReport = (payload: any) => ({
    type: GET_APPROVAL_HISTORY_REPORT,
    payload
})

const setApprovalHistoryReport = (response: any) => ({
    type: SET_APPROVAL_HISTORY_REPORT,
    response
})

const getApprovalHistoryReportExcelData = (payload: any) => ({
    type: GET_APPROVAL_HISTORY_REPORT_EXCEL_DATA,
    payload
})

const setApprovalHistoryReportExcelData = (response: any) => ({
    type: SET_APPROVAL_HISTORY_REPORT_EXCEL_DATA,
    response
})

const setApprovalManagmentTab = (payload: any) => ({type: SET_APPROVAL_MANAGMENT_TAB, payload})

const setApprovalHistoryReportFilters = (payload: any) => ({type: SET_APPROVAL_HISTORY_REPORT_FILTERS, payload})

const getApprovalHistoryReportDetails = (payload: any) => ({
    type: GET_APPROVAL_HISTORY_REPORT_DETAILS,
    payload
});

const setApprovalHistoryReportDetails = (response: any) => ({
    type: SET_APPROVAL_HISTORY_REPORT_DETAILS,
    response
});

const getApprovalHistoryDetailExcel = (payload: any) => ({
    type: GET_APPROVAL_HISTORY_DETAIL_EXCEL_DATA,
    payload
});

const setApprovalHistoryDetailExcel = (response: any) => ({
    type: SET_APPROVAL_HISTORY_DETAIL_EXCEL_DATA,
    response
});

export {
    getApprovalHistoryReport,
    setApprovalHistoryReport,
    getApprovalHistoryReportExcelData,
    setApprovalHistoryReportExcelData,
    setApprovalManagmentTab,
    setApprovalHistoryReportFilters,
    getApprovalHistoryReportDetails,
    setApprovalHistoryReportDetails,
    getApprovalHistoryDetailExcel,
    setApprovalHistoryDetailExcel
}